
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/part-exchange",
      function () {
        return require("private-next-pages/part-exchange/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/part-exchange"])
      });
    }
  